export type TParams = {
  leader_std_code?: number
  page?: number
  per_page?: number
  order_by?: string
  order_by_direction?: string
  search?: string
  enabled?: boolean
  assigned_stores?: boolean
}

export type TConcludeParams = {
  leader_std_code: number
  stores?: {
    store_tab_number: number
    description: string
  }[]
}

export enum WALLET_MANAGEMENT_STATUS_ENUM {
  ACTIVED = 1,
  CONCLUDED = 2,
  REACTIVED = 3,
  CLOSED = 4
}

export enum PERIOD_STATUS_ENUM {
  OPENED = 1,
  CLOSED = 2
}

export const WALLET_MANAGEMENT_STATUS_ENUMLabels: {
  [key in WALLET_MANAGEMENT_STATUS_ENUM]: string
} = {
  [WALLET_MANAGEMENT_STATUS_ENUM.ACTIVED]: 'Ativo',
  [WALLET_MANAGEMENT_STATUS_ENUM.CLOSED]: 'Fechado',
  [WALLET_MANAGEMENT_STATUS_ENUM.REACTIVED]: 'Ativo',
  [WALLET_MANAGEMENT_STATUS_ENUM.CONCLUDED]: 'Concluído'
}

export type TStaffListItem = {
  user_std_code: number
  user_name: string
  occupation: string
  qtd_stores: string
  profile_image_file_name: string
}

export type TLeadersListItem = {
  leader_std_code: number
  leader_user_name: string
  occupation: string
  profile_image_file_name?: string
  network: {
    network_code?: string
    network_name?: string
  }
  subsidiary: {
    subsidiary_name?: string
    subsidiary_code?: string
  }
  status: WALLET_MANAGEMENT_STATUS_ENUM
  openingDate: string
  closingDate: string
  total_specialists: number
  total_stores: number
}

export type TStoresListItem = {
  tab_number: string
  name_fantasy: string
  logo_image_file_name?: string
  segment_name: string
  subsegment_name: string
  is_store_without_subsidiary: boolean
  assigned_to_user_std_code: number
  assigned_to_user_name: string
  assigned_by_user_std_code?: number
  assigned_by_user_name?: string
  assigned_at: string
}

export type TWalletsManagementDetails = {
  started_at: string
  finished_at: string
  leader_std_code: number
  leader_user_name: string
  occupation: string
  profile_image_file_name?: string
  network: {
    network_code: string
    network_name: string
  }
  subsidiary: {
    subsidiary_name: string
    subsidiary_code: string
  }
  status: WALLET_MANAGEMENT_STATUS_ENUM
  specialists: {
    total: number
    assigned: number
  }
  tabs: {
    total: number
    assigned: number
  }
}

export type TManageWalletParams = {
  leaderStdCode: number
  userStdCode: string
  storesTabNumber: string[]
}

export type TOpenWalletsPeriodParams = {
  date_start: string
  date_end: string
  leader_std_code?: number
}

export type TWalletsManagementPeriod = {
  id: string
  year_month: number
  period_type_enum: PERIOD_TYPE_ENUM
  status: PERIOD_STATUS_ENUM
  started_at: string
  finished_at: string
  createdAt: string
  updatedAt: string
  total_leader_active: string
}

export type TStoreWithoutSubsidiaryParams = {
  leaderStdCode: number
  storeTabNumber: number
  status: boolean
}

export enum PERIOD_TYPE_ENUM {
  GENERAL = 1,
  LEADER = 2
}

export type TReportStore = {
  storeTabNumber?: string
  storeNameFantasy?: string
  subsidiaryCode?: number
  classificationGoalDescription?: string
  walletAssignmentAt?: string | null
}

export type TReportHeader = {
  leaderStdCode?: number
  leaderName?: string
  currentDate?: string
  yearMonth?: number
  startedAt?: string
  finishedAt?: string
}

export type TReportAssignedStores = {
  [key: string]: TReportStore[]
}

export type TWalletsManagementReport = {
  file_url?: string
  file_name?: string
  header?: TReportHeader
  assignedStores?: TReportAssignedStores
  unassignedStores?: TReportStore[]
}
